export const TestCaseStatuses = {
  Draft: 'Draft',
  InReview: 'In Review',
  Approved: 'Approved',
  Archived: 'Archived',
} as const

export function getTestCaseStatusLabel(status: string): string {
  return (TestCaseStatuses as Record<string, string>)[status] ?? status
}

export const TestCaseTypes = {
  Smoke: 'Smoke',
  Functional: 'Functional',
  Integration: 'Integration',
  Config: 'Config',
} as const

export const TestCasePriorities = {
  High: 'High',
  Medium: 'Medium',
  Low: 'Low',
} as const

export const TestCaseAutomationStatuses = {
  NotAutomated: 'NotAutomated',
  Planned: 'Planned',
  Automated: 'Automated',
} as const

export interface TestStep {
  stepNumber: number
  description: string
  expectedResult: string | null
}

export interface TestCase {
  id: string
  workItemId: string
  testSuiteId: string
  testCaseIdentifier: string
  title: string
  description: string | null
  status: string
  type: string
  priority: string
  lastRunAt: string | null
  failureReason: string | null
  isAutomated: boolean
  automationStatus: string
  assigneeUserId: string | null
  assigneeName: string | null
  assigneeEmail: string | null
  createdByUserId: string | null
  createdByUserName: string | null
  createdByUserEmail: string | null
  stepCount: number
  steps: TestStep[]
}

export interface LinkedWorkItem {
  id: string
  number: number | null
  title: string
  epic: string | null
  status: string
}

export interface TestCaseDetail {
  id: string
  projectId: string
  workItemId: string
  testSuiteId: string
  testCaseIdentifier: string
  title: string
  description: string | null
  status: string
  type: string
  priority: string
  lastRunAt: string | null
  failureReason: string | null
  isAutomated: boolean
  automationStatus: string
  assigneeUserId: string | null
  assigneeName: string | null
  assigneeEmail: string | null
  createdByUserId: string | null
  createdByUserName: string | null
  createdByUserEmail: string | null
  testSuiteIdentifier: string
  testSuiteTitle: string
  testPlanId: string
  testPlanTitle: string
  linkedWorkItems: LinkedWorkItem[]
  steps: TestStep[]
}

export type TestCaseSortColumn = 'number' | 'title' | 'status' | 'user'

export const TEST_CASE_DEFAULT_SORT_DIRECTIONS: Record<TestCaseSortColumn, 'asc' | 'desc'> = {
  number: 'asc',
  title: 'asc',
  status: 'asc',
  user: 'asc',
}

export const testCaseStatusFilterOptions = Object.values(TestCaseStatuses).map((status) => ({
  value: status,
  label: status,
}))

export interface TestCaseFilters {
  search?: string
  statuses?: string[]
  type?: string
  sortBy?: TestCaseSortColumn
  sortDirection?: 'asc' | 'desc'
}

export const TestCaseEditableStatuses = [
  TestCaseStatuses.Draft,
  TestCaseStatuses.Approved,
  TestCaseStatuses.InReview,
  TestCaseStatuses.Archived,
] as const

export interface UpdateTestCaseRequest {
  title: string
  status: string
  testSuiteId: string
  description?: string | null
  linkedWorkItemIds: string[]
  steps: { description: string; expectedResult: string | null }[]
}
